"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
// @ts-ignore
var react_vimeo_1 = __importDefault(require("@u-wave/react-vimeo"));
var DEFAULT_WIDTH = 400;
var VideoPlayer = styled_1.default.figure(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  iframe {\n    margin: 0 auto;\n    border-radius: 5px;\n  }\n"], ["\n  iframe {\n    margin: 0 auto;\n    border-radius: 5px;\n  }\n"])));
function Vimeo(_a) {
  var id = _a.id,
    caption = _a.caption,
    width = _a.width;
  var _b = react_1.useState(false),
    ready = _b[0],
    setReady = _b[1];
  return react_1.default.createElement(VideoPlayer, {
    className: "my-8"
  }, !ready && react_1.default.createElement("div", {
    className: "h-64 mx-auto flex items-center justify-center bg-gray-200 rounded",
    style: {
      width: width || DEFAULT_WIDTH
    }
  }, react_1.default.createElement("span", {
    className: "text-gray-400"
  }, "Loading...")), react_1.default.createElement(react_vimeo_1.default, {
    onReady: function () {
      return setReady(true);
    },
    className: "vimeo",
    video: id,
    width: width || DEFAULT_WIDTH,
    showTitle: false,
    showPortrait: false,
    showByline: false,
    autopause: false,
    background: true,
    muted: true,
    volume: 0,
    controls: false,
    loop: true
  }), !!caption && react_1.default.createElement("figcaption", {
    className: "text-center mt-4 text-xs dark:text-white"
  }, caption));
}
exports.Vimeo = Vimeo;
var templateObject_1;